// extracted by mini-css-extract-plugin
export default {"wrapper":"SuperPagination_wrapper__2GeTF","selectBlock":"SuperPagination_selectBlock__9-Xsd","text":"SuperPagination_text__s6V-s"};